import { Menu } from '@cimplico/components';
import { BellIcon } from '@heroicons/react/24/outline';
import { useHasUnreadNotifications } from '../../queries/use-has-unread-notifications';
import NotificationMenuBody from './NotificationMenuBody';

function NotificationIcon(): JSX.Element {
    const unreadNotificationsQuery = useHasUnreadNotifications();

    const hasNotifications = Boolean(unreadNotificationsQuery?.data?.hasUnreadNotifications);

    return (
        <Menu>
            <Menu.Button>
                <div className="cursor-pointer relative">
                    {hasNotifications && (
                        <div className="rounded-full border-[4px] border-solid border-yellow-500 w-1 h-1 absolute -top-[1.5px] right-[1px]" />
                    )}
                    <BellIcon className="text-white dark:text-gray-200 h-5 w-5" />
                </div>
            </Menu.Button>
            <Menu.Body position="left">
                <div className="grid items-center bg-white dark:bg-gray-800">
                    <NotificationMenuBody />
                </div>
            </Menu.Body>
        </Menu>
    );
}

export default NotificationIcon;
